import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';

const ImageModal = ({ isOpen, onClose, imageUrl }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} titleName="Image" contentWidth="50%">
      <div className="resource-view d-flex justify-content-center">
        <img src={imageUrl} className='w-100' />
      </div>
    </Modal>
  );
};

ImageModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  imageUrl: PropTypes.string
};

export default ImageModal;